document.addEventListener('DOMContentLoaded', () => {
  const parseDate = (str) => {
    if (!str) {
      return null;
    }
    return new Date(str.replace(/\b(am|pm)\b/i, match => match.toUpperCase()));
  };

  const now = new Date();

  document.querySelectorAll('.scheduled-site-notification').forEach(el => {
    let show = true;

    if (el.dataset.type === 'Scheduled') {
      const start = parseDate(el.dataset.start) || new Date('2000-01-01');
      const end   = parseDate(el.dataset.end)   || new Date('2999-12-31');

      if (now < start) {
        show = false;
      }
      if (now > end) {
        show = false;
      }
    }

    if (show) {
      el.style.display = '';
    }
  });
});